import React from 'react';
import Logo from './assets/logodark';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import './Header.css';

export default function Header (props) {
  return (
    <header className={classnames('main-header', { 'no-shadow': props.noShadow })}>
      <div className={props.wide ? 'wide-container' : 'container'}>
        <Link to="/">
          <Logo/>
        </Link>
      </div>
    </header>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Header.js